import { getCurrencyFromStorage, saveCurrencyToStorage } from './storageUtilities';
import PlanPageConstants from '../components/pages/PlanPage/PlanPageConstants';
import moment from 'moment-timezone';
import AppConstants from '../App/AppConstants';
import { USER_ROLES } from '../constants/UserRoles';

// Returns the list of all time zones
// moment.tz.names()

// The example of time zones that moment.js can return
// "US/Alaska", America/Chicago, "Europe/Amsterdam", "Europe/Kiev"

const BritishTimeZoneName = 'Europe/London';
const EuropeTimeZonePrefix = 'Europe';


export function userDoesHaveSubscription(subscriptionType) {
    return subscriptionType && (subscriptionType === AppConstants.PROFESSIONAL_SUBSCRIPTION_TYPE || subscriptionType === AppConstants.LIMITLESS_SUBSCRIPTION_TYPE);
}

export function applyDiscount(price, discountPercentage) {
    const discountAmount = (price * discountPercentage) / 100;
    const discountedPrice = price - discountAmount;

    return Math.round(discountedPrice);
}

export function getRecommendedCurrency() {
    let currency = getCurrencyFromStorage();
    
    if (currency != undefined) 
        return currency;

    // Assign the default currency 
    currency = PlanPageConstants.CURRENCIES.USD;

    // Guessing user zone
    let userTimeZone = moment.tz.guess(Boolean);

    // Assign the currency by time zones
    if (userTimeZone) {
        if (userTimeZone === BritishTimeZoneName)
            currency = PlanPageConstants.CURRENCIES.GBP;
        else if (userTimeZone.includes(EuropeTimeZonePrefix))
            currency = PlanPageConstants.CURRENCIES.EUR;
    }

    saveCurrencyToStorage(currency);
    return currency;
};

export function isAdmin(userRoles) {
    return userRoles && userRoles.length > 0 && userRoles.includes(USER_ROLES.SPECTERR_ADMIN);
};

export function isPresetsManager(userRoles) {
    return userRoles && userRoles.length > 0 && (userRoles.includes(USER_ROLES.SPECTERR_ADMIN) || userRoles.includes(USER_ROLES.PRESETS_CREATOR));
};